module.exports = __webpack_public_path__ + "src/assets/img/burger_2_white.561b99b9.svg";